import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class HeaderTitleService {

  // Observable current toggle status
  public headerTitleSource = new BehaviorSubject<string>('Default Title');

  constructor() { }

  public headerTitle$ = this.headerTitleSource.asObservable();

  // service message
  updateHeaderTitle(title: string) {
    this.headerTitleSource.next(title);
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/content-header/header-title.service.ts